import { IObjectNameIdentifier } from "../../../../../../documaker/domain/format/objects";
import { IEditableFormatObject } from "../../../../../domain/editableFormat";
import { IXElementContentsObjectBean } from "../../beans";
import { AbstractTranslator } from "../AbstractTranslator";
import { IObjectTranslatable } from "../IObjectTranslatable";
import { RelationReplacer, NameHistoriesTranslator } from "./properties";

export abstract class AbstractObjectTranslator<TObject extends IEditableFormatObject, TBean extends IXElementContentsObjectBean> extends AbstractTranslator<TObject, TBean> implements IObjectTranslatable {
  constructor(private readonly _base: IObjectTranslatable) {
    super();
  }

  fromBean(bean: TBean, formatId: number): TObject {
    const source = this._base.fromBean(bean, formatId) as TObject;
    this.overwriteObject(source, bean, formatId);
    return source;
  }

  toBean(object: TObject): TBean {
    const source = this._base.toBean(object) as TBean;
    this.overwriteBean(source, object);
    if (this.shouldRecordName(source)) {
      this.recordName(source, object._source);
    }
    return source;
  }

  abstract overwriteObject(source: TObject, bean: TBean, formatId: number): void;
  abstract overwriteBean(source: TBean, object: TObject): void;

  protected shouldRecordName(source: TBean): boolean {
    return false;
  }

  protected readName(source: TBean): IObjectNameIdentifier {
    return {
      key: source["@name"],
    };
  }

  private recordName(post: TBean, previous: TBean): void {
    if (post && previous) {
      const name = this.readName(post);
      if (!this.areNamesEqual(this.readName(previous), name)) {
        const instance = {
          nameHistories: this._nameHistories.from(post),
        };
        instance.nameHistories.push({
          value: name,
          recorded: new Date(),
        });
        this._relationReplacer.replaceBeans(post, "name-history", this._nameHistories.to(instance));
      }
    }
  }

  private areNamesEqual(a: IObjectNameIdentifier, b: IObjectNameIdentifier): boolean {
    return (this.toValidName(a.name) === this.toValidName(b.name))
        && (this.toValidName(a.key) === this.toValidName(b.key))
        && (this.toValidName(a.subKey) === this.toValidName(b.subKey));
  }

  private toValidName(source: string): string {
    // undeinfed/null/emptyは全てemptyにする.(比較時に違うと判定されないように.)
    return !source
      ? ""
      : source;
  }

  private readonly _relationReplacer = new RelationReplacer();
  private readonly _nameHistories = new NameHistoriesTranslator();
}
